import { Component } from '@angular/core';

@Component({
  selector: 'enhance-services',
  templateUrl: './enhance-services.component.html',
  styleUrls: ['./enhance-services.component.scss']
})
export class EnhanceServicesComponent {

  list = [
    {
      title: $localize`:@@professionalSupportTitle:Professional Support for Chefs`,
      subtitle: $localize`:@@professionalSupportSubtitle:Elevate your offerings with our suite of professional support services. From captivating food photography workshops to expert-led menu optimization sessions, we equip you with the tools to captivate your audience. Dive into our resources on customer service excellence to build a loyal customer base that keeps coming back for more.`,
      image: 'assets/merchant-landing-page/enhance-1.png',
      direction: 'left'
    },
    {
      title: $localize`:@@communityTitle:Community and Collaboration`,
      subtitle: $localize`:@@communitySubtitle:Join a vibrant community of culinary experts. Share recipes, ideas, and inspiration. Participate in exclusive webinars, forums, and events designed to foster collaboration and innovation among our chef partners. Together, we\\'re not just cooking; we\\'re revolutionizing home dining.`,
      image: 'assets/merchant-landing-page/enhance-2.png',
      direction: 'right'
    },
    {
      title: $localize`:@@sustainAbilityTitle:Sustainability Commitment`,
      subtitle: $localize`:@@sustainAbilitySubtitle:We\\'re committed to making a positive impact on the planet. Our platform encourages the use of locally sourced ingredients and eco-friendly packaging, helping you to contribute to a sustainable future. Learn how to integrate sustainable practices into your kitchen, reducing waste while enhancing your culinary creations.`,
      image: 'assets/merchant-landing-page/enhance-3.png',
      direction: 'left'
    }
  ]

}
